import { getDensityRowHeight } from '@Components/StickyTable/table-density';
import { DataFreshnessRunRow } from './use-data-freshness';

export interface DataFreshnessHeaderRow {
  company: string;
  source: string;
  account_id: string;
  account_name: string;
  last_updated: string;
  table_names: string[];
}

interface DataFreshnessUniqueTableNames {
  company: string;
  source: string;
  account_id: string;
  account_name: string;
  last_updated: string;
  table_names: Set<string>;
}

export const groupByEverythingExceptTableNames = (
  data: DataFreshnessRunRow[]
): DataFreshnessHeaderRow[] => {
  const groups = new Map<string, DataFreshnessUniqueTableNames>();

  const isNewer = (a: string, b: string) => Date.parse(a || '') > Date.parse(b || '');

  for (const row of data) {
    const key = JSON.stringify({
      company: row.company,
      source: row.source,
      account_id: row.account_id,
      account_name: row.account_name
    });

    const existing = groups.get(key);
    if (!existing) {
      groups.set(key, {
        company: row.company,
        source: row.source,
        account_id: row.account_id,
        account_name: row.account_name,
        last_updated: row.last_updated,
        table_names: new Set([row.table_name])
      });
    } else {
      if (isNewer(row.last_updated, existing.last_updated)) {
        existing.last_updated = row.last_updated;
      }
      existing.table_names.add(row.table_name);
    }
  }

  return Array.from(groups.values()).map(group => ({
    company: group.company,
    source: group.source,
    account_id: group.account_id,
    account_name: group.account_name,
    last_updated: group.last_updated,
    table_names: Array.from(group.table_names).sort()
  }));
};

// One line per table name (rendered by TableNamesCell in DataFreshness.tsx), so a row's
// height is exactly predictable from its table_names count.
const ROW_HEIGHT_BASE = 16;
const ROW_HEIGHT_PER_TABLE_NAME = 20;
const MIN_ROW_HEIGHT = getDensityRowHeight();

export const getDataFreshnessRowHeight = (row: DataFreshnessHeaderRow): number =>
  Math.max(MIN_ROW_HEIGHT, ROW_HEIGHT_BASE + row.table_names.length * ROW_HEIGHT_PER_TABLE_NAME);
